/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { Component } from 'react';
import ClipboardView from './Clipboard.view';
import { ReadOnlyTextFieldView } from './ReadOnlyTextField.view';
import { InputAdornment, StandardTextFieldProps, Tooltip } from '@mui/material';

export interface Props {
	textToCopy: string;
	values: StandardTextFieldProps;
}

interface State {
	showCopyIcon: boolean;
}
class ReadOnlyTextFieldWithClipboardView extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			showCopyIcon: false
		};
		this.showCopyIcon = this.showCopyIcon.bind(this);
		this.hideCopyIcon = this.hideCopyIcon.bind(this);
	}

	hideCopyIcon(): void {
		this.setState({ showCopyIcon: false });
	}

	showCopyIcon(): void {
		this.setState({ showCopyIcon: true });
	}

	render(): JSX.Element {
		const { showCopyIcon } = this.state;
		const { values, textToCopy } = this.props;
		const { id, name, label, type, value, InputLabelProps, error, helperText } = values;

		return (
			<Tooltip title={textToCopy} placement="bottom-end">
				<ReadOnlyTextFieldView
					id={id}
					name={name}
					label={label}
					type={type}
					value={value}
					InputProps={{
						readOnly: true,
						endAdornment: value ? (
							<InputAdornment position="end">
								<ClipboardView textToCopy={textToCopy} showCopyIcon={showCopyIcon} />
							</InputAdornment>
						) : (
							<></>
						)
					}}
					InputLabelProps={InputLabelProps}
					error={error}
					helperText={helperText}
					onMouseOver={this.showCopyIcon}
					onMouseLeave={this.hideCopyIcon}
					fullWidth
				/>
			</Tooltip>
		);
	}
}
export default ReadOnlyTextFieldWithClipboardView;
